// extracted by mini-css-extract-plugin
export var animation_pulse = "Skeleton_animation_pulse__Na3ND";
export var animation_wave = "Skeleton_animation_wave__BLpYb";
export var circular = "Skeleton_circular__78CVe";
export var pulse = "Skeleton_pulse__5QAlL";
export var rectangular = "Skeleton_rectangular__Fm+hr";
export var skeleton = "Skeleton_skeleton__MgvsQ";
export var text = "Skeleton_text__TAYVw";
export var wave = "Skeleton_wave__Oap6n";